import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 21",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M6.6665 2.75195L13.3332 4.4183L16.1396 3.48302C17.2188 3.12335 18.3332 3.92663 18.3332 5.06419V14.884C18.3332 15.6014 17.8741 16.2383 17.1936 16.4652L13.3332 17.752L6.6665 16.0853L3.86022 17.0207C2.781 17.3805 1.6665 16.5772 1.6665 15.4396V5.61989C1.6665 4.9025 2.12555 4.2656 2.80612 4.03875L6.6665 2.75195ZM5.83317 4.78655V14.6062L3.33317 15.4396L3.33317 5.61988L5.83317 4.78655ZM7.49984 14.5757V4.67819L12.4998 5.92794V15.8257L7.49984 14.5757ZM14.1665 15.7174L16.6665 14.884V5.06419L14.1665 5.89736V15.7174Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}